import styled from 'styled-components';
const LandUsePlan = ({ landUsePlan, linkSet }: any) => {
const link = '';
  return (
    <Container>
      <Header style={{ marginBottom: '16px', fontWeight:'500'  }}>
        <img src="/assets/images/icon/land_analysis.svg"/>
        토지이용계획
      </Header>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontFamily: 'Spoqa Han Sans Neo',
          fontWeight: '500',
          fontSize: '14px',
          textAlign: 'center',
          border: '1px solid #E8E9EA',
          lineHeight: '20.30px',
          borderSpacing: '0',
          borderTop: '1px solid #616161',
          marginBottom:'24px'
        }}
      >
        <tbody style={{ }}>
          <tr>
            <td
              style={{
                color: '#616161',
                padding: '10px 12px',
                width: '110px',
                textAlign: 'center',
                wordWrap: 'break-word',
                fontSize: '13px',
                lineHeight: '18.85px',
                backgroundColor: '#F7F8FC',
              }}
              rowSpan={3}
            >
              국토의 계획 및<br />
              이용에 관한 법률
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              포함
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.contain.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw1.contain.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              저촉
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.conflict.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw1.conflict.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              접합
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw1.touch.map((item: string, index: number) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  {item}
                  {index !== landUsePlan.landLaw1.touch.length - 1 && ','}
                </div>
              ))}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#616161',
                padding: '10px 12px',
                width: '110px',
                textAlign: 'center',
                backgroundColor: '#F7F8FC',
                fontSize: '13px',
                lineHeight: '18.85px',

              }}
              rowSpan={3} // 숫자로 전달
            >
              기타법률
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              포함
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.contain.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw2.contain.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              저촉
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.conflict.map(
                (item: string, index: number) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    {item}
                    {index !== landUsePlan.landLaw2.conflict.length - 1 && ','}
                  </div>
                ),
              )}
            </td>
          </tr>
          <tr style={{ borderBottom: '1px solid #E8E9EA' }}>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
                width: '51px',
                borderRight: '1px #E8E9EA solid',
              }}
            >
              접합
            </td>
            <td
              style={{
                color: '#171E26',
                padding: '10px 12px',
                textAlign: 'center',
              }}
            >
              {landUsePlan.landLaw2.touch.map((item: string, index: number) => (
                <div key={index} style={{ textAlign: 'center' }}>
                  {item}
                  {index !== landUsePlan.landLaw2.touch.length - 1 && ','}
                </div>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
      {/** 토지이음, 시리얼, 네이버 메뉴 */}
      <OutLinkContainer>
        <OutLinkBox
          onClick={() => {
          if (linkSet?.landUsePlanLink) {
            window.open(linkSet?.landUsePlanLink || '', '_blank');
          }
          }}
        style={{
            opacity: linkSet?.landUsePlanLink ? 1 : 0.2,
            pointerEvents: linkSet?.landUsePlanLink ? 'auto' : 'none',
            cursor: linkSet?.landUsePlanLink ? 'pointer' : 'not-allowed',
          }}
        >
          <OutLinkContent>
            <ImageMargin>
              <img src="/assets/images/logo/land_use_logo.svg" alt="토지이음로고" />
            </ImageMargin>
            <div>
              <OutLinkLogo>토지이음</OutLinkLogo>
              <OutLinkTitle>토지이용계획,도시계획 열람</OutLinkTitle>
            </div>
          </OutLinkContent>
            <img src="/assets/images/arrow/arrow_right_up.svg" alt="방문하기" />
        </OutLinkBox>
            
        <OutLinkBox
          onClick={() => {
            if (!linkSet?.serialLink) return;
            window.open(linkSet.serialLink, '_blank');
          }}
          style={{
            opacity: linkSet?.serialLink ? 1 : 0.2,
            pointerEvents: linkSet?.serialLink ? 'auto' : 'none',
            cursor: linkSet?.serialLink ? 'pointer' : 'not-allowed',
          }}
        >
          <OutLinkContent>
            <ImageMargin>
              <img src="/assets/images/logo/Logo_Seereal.svg" alt="씨리얼얼로고" />
            </ImageMargin>
            <div>
                <OutLinkLogo>SEE:REAL</OutLinkLogo>
                <OutLinkTitle>부동산종합정보지도 열람</OutLinkTitle>
            </div>
          </OutLinkContent>
            <img src="/assets/images/arrow/arrow_right_up.svg" alt="방문하기" />
        </OutLinkBox>
            
        <OutLinkBox
        onClick={() => {
        if (!link) return;
        window.open(link, '_blank');
      }}
        style={{
        opacity: link ? 1 : 0.2,
        pointerEvents: link ? 'auto' : 'none',
        cursor: link ? 'pointer' : 'not-allowed',
      }}>
          <OutLinkContent>
            <ImageMargin>
              <img src="/assets/images/logo/Logo_Naver.svg" alt="네이버로고" />
            </ImageMargin>
            <div>
                <OutLinkLogo>NAVER</OutLinkLogo>
                <OutLinkTitle>네이버 부동산 매물</OutLinkTitle>
            </div>
          </OutLinkContent>
            <img src="/assets/images/arrow/arrow_right_up.svg" alt="방문하기" />
        </OutLinkBox>
    </OutLinkContainer>
    </Container>
  );
};

export default LandUsePlan;

const Container = styled.div`
  width: 100%;
  min-height: 148px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: 24px; */

  color: #222222;
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 17.4px;
  word-wrap: break-word;
  span {
    color: #0052bd;
    font-size: 9px;
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    line-height: 13.05px;
    word-wrap: break-word;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  font-size: 16px;
`;

const OutLinkContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  color: #222222;
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 17.4px;
  word-wrap: break-word;
`

const OutLinkBox= styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e5e8ea;
  border-radius: 4px;
  cursor: pointer;
`

const OutLinkContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const ImageMargin = styled.span`
  display: flex;
  max-width: 100%;
  height: auto;
  margin-right: 8px;
`

const OutLinkLogo = styled.div`
  font-size: 9px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  &:first-of-type {
    color: #434D96; 
  }
    &:nth-of-type(2) {
    color: #434D96; 
  }
    &:last-of-type {
    color: #434D96; 
  }
`

const OutLinkTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 17.4px;
  letter-spacing: -0.05em;
`